<script>
export default {
    data() {
        return {
            searchKeyword: '',
        }
    },
    computed: {
        routeKeyword() {
            return this.$route && this.$route.params && this.$route.params.keyword
        },
        fromRoute() {
            return this.$store.state.search.previousRoute
        },
    },
    mounted() {
        if (this.routeKeyword) {
            this.searchKeyword = this.routeKeyword.replace(/_/g, ' ')
            this.$store.commit('search/UPDATE_KEYWORD', this.searchKeyword)
        }
        this.$refs.searchInput.focus()
        !this.$store.state.route.from.fullPath.includes('search') &&
            this.$store.commit('search/UPDATE_PREVIOUS_ROUTE', this.$store.state.route.from)
    },
    methods: {
        onSearch(keyword) {
            this.$store.commit('search/UPDATE_KEYWORD', (keyword || '').replace(/_/g, ' '))
        },
        onClose() {
            if (this.searchKeyword && this.searchKeyword.length) {
                this.searchKeyword = ''
            } else {
                this.$router.push({ path: this.fromRoute.path, query: { back: true } })
            }
        },
    },
}
</script>

<template>
    <div :class="$style.searchBar">
        <BaseSearchInput
            ref="searchInput"
            v-model="searchKeyword"
            placeholder="What do you want to listen to?"
            :input-class="$style.searchInput"
            :search-icon-class="[$style.icon, $style.iconSearch]"
            autofocus
            @search="onSearch"
        >
            <template #append>
                <a @click="onClose">
                    <BaseIcon
                        :class="[$style.icon, $style.iconClose]"
                        name="x"
                    />
                </a>
            </template>
        </BaseSearchInput>
    </div>
</template>

<style lang="scss" module>
@import '@design';

.searchBar {
    display: flex;
    align-items: center;
    width: 100%;
    height: $size-search-bar-height;
    padding: 0 $s-xl;
    background-color: $c-searchbar-bg;
}
.icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    fill: $c-white;

    &Close {
        cursor: pointer;
    }

    &Search {
        margin-right: $s-m;
        opacity: 0;

        @include desktop {
            width: 40px;
            height: 40px;
            opacity: 1;
        }
    }
}
.searchInput {
    flex: 1;
    min-width: 0;
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
    color: $c-white;
    text-align: center;
    letter-spacing: -0.83px;
    background: none;
    border: none;
    outline: none;

    @media (min-width: $desktop) {
        font-size: 40px;
        line-height: 55px;
        text-align: left;
        letter-spacing: -1px;
    }

    &::placeholder {
        color: transparentize($color: $c-white, $amount: 0.2);
    }
}
</style>
